let _app: IModule | null = null;
const _queue: Array<() => void> = [];
export const registeredComponents = new Set<string>();

export const lazyRegister = {
    setModule: (app: IModule) => {
        _app = app;
        while (_queue.length > 0) {
            const fn = _queue.shift();
            if (fn) fn();
        }
    },
    getModule() {
        return _app;
    },
    controller: (name: string, provider: any) => {
        if (registeredComponents.has(name)) {
            return;
        }

        const action = () => {
            if (!_app) return;
            try {
                const registerFn = _app.registerController || _app.controller;
                registerFn.call(_app, name, provider);
                registeredComponents.add(name);
            } catch (e) {
                console.error('LazyRegister controller error:', e);
            }
        };

        if (_app) {
            action();
        } else {
            _queue.push(action);
        }
    },
    service: (name: string, provider: any) => {
        const action = () => {
            if (!_app) return;
            try {
                const registerFn = _app.registerService || _app.service;
                registerFn.call(_app, name, provider);
            } catch (e) {
                console.error('LazyRegister service error:', e);
            }
        };

        if (_app) {
            action();
        } else {
            _queue.push(action);
        }
    },
    component: (name: string, options: any) => {
        if (registeredComponents.has('com_' + name)) return;
        const action = () => {
            if (!_app) return;
            try {
                const registerFn = _app.registerComponent || _app.component;
                registerFn.call(_app, name, options);
                registeredComponents.add('com_' + name);
            } catch (e) {
                console.error('LazyRegister component error:', e);
            }
        };

        if (_app) {
            action();
        } else {
            _queue.push(action);
        }
    },
    factory: (name: string, options: any) => {
        const action = () => {
            if (!_app) return;
            try {
                const registerFn = _app.registerFactory || _app.factory;
                registerFn.call(_app, name, options);
            } catch (e) {
                console.error('LazyRegister factory error:', e);
            }
        };

        if (_app) {
            action();
        } else {
            _queue.push(action);
        }
    },
    filter: (name: string, options: any) => {
        const action = () => {
            if (!_app) return;
            try {
                const registerFn = _app.registerFilter || _app.filter;
                registerFn.call(_app, name, options);
            } catch (e) {
                console.error('LazyRegister filter error:', e);
            }
        };

        if (_app) {
            action();
        } else {
            _queue.push(action);
        }
    },
    directive: (name: string, options: any) => {
        if (registeredComponents.has('dir_' + name)) return;
        const action = () => {
            if (!_app) return;
            try {
                const registerFn = _app.registerDirective || _app.directive;
                registerFn.call(_app, name, options);
                registeredComponents.add('dir_' + name);
            } catch (e) {
                console.error('LazyRegister directive error:', e);
            }
        };

        if (_app) {
            action();
        } else {
            _queue.push(action);
        }
    },
};
